{
  "password": {
    "oneNumber": "Пароль должен содержать не менее 1 цифры",
    "oneSymbol": "Пароль должен содержать не менее 1 спец. символа",
    "oneLowerCase": "Пароль должен содержать не менее 1 прописной латинской буквы",
    "oneUpperCase": "Пароль должен содержать не менее 1 заглавной латинской буквы",
    "minSymbols": "Пароль должен состоять из латинских букв, цифр и спец. символов, не менее 8 знаков",
    "maxSymbols": "Пароль не длиннее 255 знаков",
    "notEqual": "2 пароля, которые вы ввели, не равны"
  },
  "form": {
    "required": "Обязательно к заполнению",
    "ipValidate": "Некорреткный IP",
    "notValid": "Форма не валидна",
    "requiredError": "Необходимо заполнить обязательные поля",
    "incorrectFormat": "Некорректный формат",
    "incorrectValue": "Некорректное значение",
    "domain": "Допустимы только латинские буквы, цифры, точки и дефисы",
    "maxLength": "Не более {{max}} символов",
    "passwordsMismatch": "Пароли не совпадают",
    "missingOption": "Выбранная опция недоступна",
    "rjsf": {
      "incorrectSchema": "Некорректный формат схемы"
    },
    "latinWithScores": "Только латинские буквы, цифры и подчеркивания"
  },
  "oidc": {
    "nameFormat": "Имя должно начинаться с буквы и содержать только строчные латинские буквы, цифры и подчеркивание"
  },
  "required": "Обязательное поле",
  "max": "Превышен максимум",
  "min": "Недостаточный минимум"
}